import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Anchor = styled("a")`
    font-family: ${({theme}) => theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body2.fontWeight};
    text-transform: ${({theme}) => theme.uxfabric.global.body2.textTransform};
    letter-spacing: ${({theme}) => theme.uxfabric.global.body2.letterSpacing};
    line-height: ${({theme}) => theme.uxfabric.global.body2.lineHeight};
    padding-right: 0.875rem;
    color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.textColor};
    text-decoration: none;
    display: flex;
    align-items: center;
    background: transparent !important;
    @media (max-width: ${breakpoints.values.md}px) {
        display: none;
    }
`
